export function setPrefix(url) {
    let result = ''
  if (window.location.host.indexOf('localhost') > -1) {
    result = 'http://zjk.ciur.org.cn' + url
  } else {
    result = url
  }
  return result
}